import type { Client } from '../../api/client.js';
import type { ApercuLien, PageArrivee } from './contrat.js';

const LIBELLES: Readonly<Record<PageArrivee, string>> = {
  accueil: 'Accueil de l’espace',
  piece: 'Dépôt d’une pièce',
  paiement: 'Règlement de la quote-part',
  confidentialite: 'Confidentialité et partages',
  progression: 'Suivi de la progression',
};

export const PAGES_ARRIVEE = Object.keys(LIBELLES) as PageArrivee[];

export const libelleArrivee = (page: PageArrivee): string => LIBELLES[page];

/** Aperçu exact du lien tel que le destinataire le verra (générique, sans donnée personnelle). */
export async function chargerApercuLien(client: Client, page: PageArrivee): Promise<ApercuLien | null> {
  try {
    return await client.appeler<ApercuLien>('messagerie.apercuLien', { requete: { page } });
  } catch {
    return null;
  }
}
